import { useParams } from 'react-router';
import { InvalidRouteIntParamError } from 'const';

function throwIfNaN(value: number, paramName: string, rawValue: string) {
  if (Number.isNaN(value)) {
    throw new InvalidRouteIntParamError(paramName, rawValue);
  }
}

export const useIntParam = (paramName: string) => {
  const params = useParams();
  const rawValue = params[paramName] ?? '';
  const paramValue = Number.parseInt(rawValue, 10);

  throwIfNaN(paramValue, paramName, rawValue);

  return paramValue;
};

export const useOptionalIntParam = (paramName: string) => {
  const params = useParams();
  const rawValue = params[paramName];

  if (!rawValue) {
    return undefined;
  }

  const paramValue = Number.parseInt(rawValue, 10);

  throwIfNaN(paramValue, paramName, rawValue);

  return paramValue;
};
